const getStorage = (type = "local") => {
  if (typeof window === "undefined") return null;

  try {
    if (type === "session") return window.sessionStorage;
    return window.localStorage;
  } catch (error) {
    console.error(`Storage unavailable for ${type}:`, error);
    return null;
  }
};

export const createStorage = (type = "local") => ({
  set: (key, value) => {
    try {
      const storage = getStorage(type);
      if (storage) storage.setItem(key, String(value));
    } catch (error) {
      console.error(`Error saving to ${type}Storage:`, error);
    }
  },

  get: (key) => {
    try {
      const storage = getStorage(type);
      return storage ? storage.getItem(key) : null;
    } catch (error) {
      console.error(`Error reading from ${type}Storage:`, error);
      return null;
    }
  },

  remove: (key) => {
    try {
      const storage = getStorage(type);
      if (storage) storage.removeItem(key);
    } catch (error) {
      console.error(`Error removing from ${type}Storage:`, error);
    }
  },

  clear: () => {
    try {
      const storage = getStorage(type);
      if (storage) storage.clear();
    } catch (error) {
      console.error(`Error clearing ${type}Storage:`, error);
    }
  },
});
